const HIDDEN_COLUMN_CLASS = 'dx-datagrid-hidden-column';
const ANT_HIDDEN_MARK = 'antAdaptiveHidden';

// columnHidingEnabled: DevExtreme ẩn cột bằng width 0.0001px + class dx-datagrid-hidden-column.
// Ô dữ liệu được gắn class mỗi lần render, nhưng ô header chỉ được gắn ở lượt tính lại
// adaptive — header render lại sau đó (vd best-fit đổi width cột) thì mất class. Chữ header
// của cột rộng 0 bị CSS ant-grid (white-space normal + overflow-wrap anywhere) xuống dòng
// từng ký tự, kéo cả dòng header cao vài trăm px. Gắn lại class theo độ rộng <col>.
export const markAdaptiveHiddenHeaderCells = (element) => {
    if (!element) return false;
    let changed = false;
    element.querySelectorAll('.dx-datagrid-headers table').forEach((table) => {
        const colgroup = Array.from(table.children).find((child) => child.tagName === 'COLGROUP');
        if (!colgroup) return;
        const cols = colgroup.children;
        table.querySelectorAll('.dx-header-row > td[aria-colindex]').forEach((cell) => {
            if (cell.colSpan > 1) return;
            const col = cols[Number(cell.getAttribute('aria-colindex')) - 1];
            if (!col || !col.style.width) return;
            const hidden = parseFloat(col.style.width) < 1;
            if (hidden && !cell.classList.contains(HIDDEN_COLUMN_CLASS)) {
                cell.classList.add(HIDDEN_COLUMN_CLASS);
                cell.dataset[ANT_HIDDEN_MARK] = '1';
                changed = true;
            } else if (!hidden && cell.dataset[ANT_HIDDEN_MARK]) {
                cell.classList.remove(HIDDEN_COLUMN_CLASS);
                delete cell.dataset[ANT_HIDDEN_MARK];
                changed = true;
            }
        });
    });
    return changed;
};

// Theo dõi header render lại / <col> đổi width để gắn class trước khi trình duyệt vẽ.
export const observeAdaptiveHiddenHeaders = (element) => {
    if (!element || typeof MutationObserver === 'undefined') return () => {};
    markAdaptiveHiddenHeaderCells(element);
    const observer = new MutationObserver((mutations) => {
        const touchesHeader = mutations.some((mutation) => {
            const target = mutation.target;
            return target && target.closest && target.closest('.dx-datagrid-headers');
        });
        if (touchesHeader) markAdaptiveHiddenHeaderCells(element);
    });
    observer.observe(element, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    return () => observer.disconnect();
};

// DevExtreme 22.2 synchronizes fixed headers with inline TR heights. Those
// heights can survive narrower captions / wider columns and prevent shrinking.
export const resetGridHeaderHeights = (element) => {
    if (!element || element.getBoundingClientRect().width <= 0) return false;
    markAdaptiveHiddenHeaderCells(element);
    const rows = Array.from(element.querySelectorAll('.dx-datagrid-headers .dx-header-row'));
    const previousHeights = rows.map((row) => row.getBoundingClientRect().height);
    rows.forEach((row) => { row.style.height = ''; });

    // Measure after clearing BOTH tables, then synchronize each band separately.
    const naturalHeights = rows.map((row) => row.getBoundingClientRect().height);
    const bandHeights = new Map();
    rows.forEach((row, index) => {
        bandHeights.set(row.rowIndex, Math.max(bandHeights.get(row.rowIndex) || 0, naturalHeights[index]));
    });
    rows.forEach((row, index) => {
        const height = bandHeights.get(row.rowIndex);
        if (height > naturalHeights[index]) row.style.height = `${height}px`;
    });
    return rows.some((row, index) => Math.abs(bandHeights.get(row.rowIndex) - previousHeights[index]) > 0.5);
};

export const reconcileGridHeaderLayout = (instance) => {
    if (!instance) return false;
    const root = instance.element?.();
    const element = root?.get ? root.get(0) : root;
    const changed = resetGridHeaderHeights(element);
    if (changed) instance.updateDimensions?.();
    return changed;
};
